import {
  Sprite,
  Object3D,
  CanvasTexture,
  SpriteMaterial,
  BoxGeometry,
  MeshBasicMaterial,
  Mesh,
  TextureLoader
} from 'three'
import { HashMap } from '../../ts/core/HashMap'

class LocationSprite extends Object3D {
  static getSpriteByName(name_) {
    let sp_ = this.hash.get(name_)
    if (!sp_) {
      sp_ = new LocationSprite(name_)
      this.hash.put(name_, sp_)
    }
    return sp_
  }

  /**     * 获取指示牌     */
  static getSprite(name_) {
    let _indicator = null
    if (LocationSprite.sprites.length > 0) {
      _indicator = LocationSprite.sprites.pop()
    } else {
      _indicator = new LocationSprite(name_)
    }
    return _indicator
  }

  /**     * 回收指示牌     */
  static recSprite(_sprite) {
    LocationSprite.sprites.push(_sprite)
  }

  constructor(name_) {
    super()
    this.locationName = name_
    this.init()
  }

  /**
   * 刷新精灵图
   * @param {精灵图} sprite_
   */
  updateSprite(sprite_) {
    if (this.sprite) {
      this.remove(this.sprite)
    }
    this.sprite = sprite_
    this.add(sprite_)
  }

  init() {
    this.nameTexture = new CanvasTexture(this.initCanvas())
    this.nameSprite = new Sprite(
      new SpriteMaterial({ map: this.nameTexture, depthTest: false })
    )
    this.nameSprite.scale.set(1500, 1500, 1)
    this.add(this.nameSprite)

    this.selectMesh = new Mesh(
      LocationSprite.selectGeo,
      LocationSprite.selectMaterial
    )
    this.add(this.selectMesh)
  }
  update() {}
  dispose() {}

  updateName(name_) {
    this.locationName = name_
    this.nameSprite.material.map = new CanvasTexture(this.initCanvas())
    this.nameSprite.material.needsUpdate = true
  }

  initCanvas() {
    let canvas = this.canvas || document.createElement('canvas')
    canvas.width = canvas.height = 256
    let context = canvas.getContext('2d')

    context.font = 'normal normal normal 22px Airal'
    context.fillStyle = '#FFF'
    context.strokeStyle = '#000'
    context.lineWidth = 2
    context.lineCap = 'round'
    context.lineJoin = 'round'
    let reg = /^[a-zA-Z]/gi
    if (reg.test(this.locationName)) {
      this.drawLineText(canvas, context)
    } else {
      this.drawCircleText(canvas, context)
    }
    this.canvas = canvas
    return canvas
  }

  drawLineText(canvas, context) {
    //debugger;
    context.textAlign = 'center'
    context.textBaseline = 'middle'
    context.lineWidth = 2
    context.strokeText(this.locationName, 128, 170)
    context.fillText(this.locationName, 128, 170)
  }

  drawCircleText(canvas, context) {
    let circle = {
      x: canvas.width / 2,
      y: -20,
      radius: 200
    }

    if (!this.locationName) return

    let string = this.locationName
    let itemAngle = 0.12
    let reg = /^[a-zA-Z]/gi
    if (reg.test(string)) {
      itemAngle *= 0.6
    }
    let centerAngle = -(Math.PI / 2)
    let total = string.length * itemAngle
    let startAngle = centerAngle - total / 2
    let radius = circle.radius // 圆的半径
    let angle = startAngle // 转一下数字
    let index = 0
    let character

    context.save()

    while (index < string.length) {
      character = string.charAt(index)
      context.save()
      context.beginPath()
      context.translate(
        circle.x + Math.cos(angle) * radius,
        circle.y - Math.sin(angle) * radius
      )
      context.rotate(-Math.PI / 2 - angle) // Math.PI/2为旋转90度  Math.PI/180*X为旋转多少度
      context.strokeText(character, 0, 0)
      context.fillText(character, 0, 0)
      angle += itemAngle
      index++
      context.restore()
    }
    context.restore()
  }
}

LocationSprite.hash = new HashMap()
LocationSprite.sprites = []
LocationSprite.locationImage = null
/**     * 基础属性     */
LocationSprite.selectGeo = new BoxGeometry(500, 900, 500)
LocationSprite.selectTexture = null

LocationSprite.arrowMaterial = new SpriteMaterial({
  map: new TextureLoader().load('./static/textures/markers/jt.png'),
  depthTest: false
})

LocationSprite.selectMaterial = new MeshBasicMaterial({
  color: 0xff0000,
  transparent: true,
  depthTest: false,
  opacity: 0
})

export { LocationSprite }



// WEBPACK FOOTER //
// ./src/webgl/marker/LocationSprite.js